import { connect } from 'react-redux'
import { actionCreators } from 'store/modules/dialogs'
import dialogTypes from 'dialogs/dialogTypes'
export { dialogTypes }

export const withDialogs = (component) =>
  connect(
    ({ dialogs }) => ({ dialogs }),
    {
      showDialog: actionCreators.showDialog,
      hideDialog: actionCreators.hideDialog,

      showAlert: ({ message }) => actionCreators.showDialog({
        dialogType: dialogTypes.alert,
        context: { message }
      }),
      showConfirm: ({ confirmTitle, confirmMessage, onConfirm }) => actionCreators.showDialog({
        dialogType: dialogTypes.confirm,
        context: {
          title: confirmTitle,
          message: confirmMessage,
          onConfirm
        }
      })
    }
  )(component)
